import React from "react";
import Flash from "../../../../assets/icons/Flash.svg";

const StreaksCard = () => {
  return (
    <div
        className="min-w-[100px] sm:w-[130px] md:w-[150px] lg:w-[180px]
             min-h-[100px] sm:h-[130px] md:h-[150px] lg:h-[180px]
             rounded-[20px] sm:rounded-[30px] lg:rounded-[40px]
             bg-black flex items-center justify-center
             transition duration-300 ease-in-out
             hover:scale-[1.03] hover:shadow-[0_4px_15px_rgba(255,255,255,0.08)]
             group"
    >


      <div className="w-14 h-16 bg-transparent flex items-center justify-center">
        <img
          src={Flash}
          alt="Streaks Flash Icon"
          className="w-14 h-14 object-contain transition duration-300 ease-in-out group-hover:drop-shadow-[0_0_10px_#FFE066]"
        />
      </div>
    </div>
  );
};

export default StreaksCard;
